import Icon from '../../../components/ui/AppIcon';
import LeadCaptureForm from './LeadCaptureForm';

const FinalConversion = () => {
  return (
    <section id="apply-now" className="py-10 bg-gradient-to-br from-primary/10 via-background to-accent/10">
      <div className="max-w-content mx-auto px-section-margin">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <div className="inline-flex items-center space-x-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-2 mb-6">
                <Icon name="ClockIcon" size={20} className="text-accent" variant="solid" />
                <span className="text-sm font-semibold text-accent">Limited Counseling Slots Available</span>
              </div>
              <h2 className="text-2xl md:text-2xl font-bold text-text-primary mb-4">
                Take the First Step Towards Your Career Upgrade
              </h2>
              <p className="text-md text-text-secondary">
                Join thousands of working professionals who transformed their careers with D.Y. Patil Online MBA. Get instant counseling and personalized guidance.
              </p>
            </div>

            {/* Benefits */}
            <div className="space-y-4">
              {[
                {
                  icon: 'CheckCircleIcon',
                  title: 'Free Career Counseling',
                  description: 'Expert guidance on specialization selection and career path',
                },
                {
                  icon: 'CurrencyRupeeIcon',
                  title: 'Transparent Fee Structure',
                  description: 'No hidden charges, easy EMI options available',
                },
                {
                  icon: 'ClockIcon',
                  title: 'Quick Admission Process',
                  description: 'Get admitted within 48 hours of document submission',
                },
                {
                  icon: 'ShieldCheckIcon',
                  title: 'UGC Approved Degree',
                  description: 'Recognized by government and private sectors nationwide',
                },
              ].map((benefit, index) => (
                <div key={index} className="flex items-start space-x-4 bg-background rounded-lg p-3 border border-border">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon name={benefit.icon as any} size={24} className="text-primary" variant="solid" />
                  </div>
                  <div>
                    <h5 className="font-bold text-text-primary mb-1">{benefit.title}</h5>
                    <p className="text-sm text-text-secondary benifits_descitpion_text">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Trust Indicators */}
            <div className="bg-success/10 border border-success/20 rounded-xl p-3">
              <div className="flex items-center space-x-3 mb-2">
                <Icon name="UserGroupIcon" size={32} className="text-success" variant="solid" />
                <div>
                  <div className="text-2xl font-bold text-success">15,847</div>
                  <div className="text-sm text-text-secondary">Professionals enrolled this year</div>
                </div>
              </div>
              <div className="flex items-center space-x-2 text-sm text-text-secondary">
                <Icon name="ClockIcon" size={16} className="text-success" variant="solid" />
                <span>Average response time: 2 hours</span>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div>
            <div className="bg-background rounded-2xl shadow-2xl p-8 border-2 border-primary/20">
              <div className="text-center mb-3">
                <h3 className="text-2xl font-bold text-text-primary mb-2">
                  Apply Now for Free Counseling
                </h3>
                <p className="text-text-secondary">
                  Fill the form below and our expert will contact you within 24 hours
                </p>
              </div>

              <LeadCaptureForm />

              {/* Alternative Contact Options */}
              {/* <div className="mt-4 pt-4 border-t border-border">
                <p className="text-center text-sm text-text-secondary mb-4">
                  Prefer to talk directly? Contact us now:
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <a
                    href="tel:+919405709042"
                    className="flex items-center justify-center space-x-2 bg-secondary text-secondary-foreground px-2 py-3 rounded-lg font-semibold hover:bg-secondary/90 transition-default"
                  >
                    <Icon name="PhoneIcon" size={20} variant="solid" /> 
                    <span>Call Now</span>
                  </a>
                  <a
                    href="https://wa.me/919730088168"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-2 bg-success text-success-foreground px-2 py-3 rounded-lg font-semibold hover:bg-success/90 transition-default"
                  >
                    <Icon name="ChatBubbleLeftRightIcon" size={20} variant="solid" />
                    <span>WhatsApp</span>
                  </a>
                </div>
              </div> */}
            </div>

            {/* Privacy Assurance */}
            <div className="mt-6 flex items-start space-x-2 text-sm text-text-secondary">
              <Icon name="LockClosedIcon" size={16} className="flex-shrink-0 mt-0.5" variant="solid" />
              <p>
                Your information is secure and will only be used for counseling purposes. We respect your privacy and never share your data with third parties.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalConversion;